import React, { Fragment,Component } from 'react';
import houseof from '../../components/images/HouseOf_medium.png';

class contribute extends Component {
    render() {
        return (
            <Fragment>
                <div className='img-container'>
                    <img src={houseof} alt="house"/>
                </div>
                <div className="body-container">
                    <br/>
                    <div className="CenteredTitle">Ways to Contribute</div>
                    <br/>
                    <div className="text-center">
                    Contributions come in all forms and all types of contributions are welcome.
                    Sharing ideas or opinions about our work helps us improve our site and software.
                    In turn, you end up with a better product. While donations help us “keep the lights on”, constructive criticism is always welcome and we take it seriously. Please let us know what you would like to see or what it is you think the applications can add to make your job easier.
                    <br/><a href="mailto:mytestingtools.com@gmail.com?subject=A Contribution" className="">Click here to contact us now!</a>

                    <br/><br/>
                    Our website and all applications offered by VERA on this site run on donations.
                    Your contributions help maintain this site and allow us to invest more time in building more tools.
                    If you find our tools helpful in any way, consider making a donation to help keep this website running.
                    <br/><a href="https://www.paypal.com/donate/?hosted_button_id=FFERGTCZNAFLN" className="">Donate Today!</a>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default contribute



// WEBPACK FOOTER //
// ./src/components/layout/contribute.js